export default __webpack_public_path__ + "static/media/poshmark.4d68c944.svg";